export interface FocusItem {
  id: string;
  index: string;
  title: string;
  brief: string;
  note: string;
  tag: string;
  size: "lg" | "sm";
  tone: "primary" | "accent" | "secondary";
}

export const focusItems: FocusItem[] = [
  {
    id: "name",
    index: "Q1",
    title: "真名：叫得出名字的人始终没有出现",
    brief:
      "从早期评论区到最近几轮讨论，被点名“对号入座”的名字出现过好几个，但没有任何一个能得到当事人或可信渠道的确认，多数停留在“看起来像”的猜测层面。",
    note: "目前 0 条被证实，仍属猜测口径。",
    tag: "真名追查",
    size: "lg",
    tone: "primary",
  },
  {
    id: "photo",
    index: "Q2",
    title: "照片：几张“据说是本人”的图均无来源背书",
    brief:
      "流传的照片大多来自粉丝群转发，画质不一、时间戳对不上，缺少能构成证据链的原始出处。",
    note: "无有效来源，谨慎引用。",
    tag: "照片线索",
    size: "sm",
    tone: "accent",
  },
  {
    id: "bg",
    index: "Q3",
    title: "背景：像是懂行的“圈内人”，具体履历成谜",
    brief:
      "从爆料角度、用词习惯和掌握细节判断，普遍推测其有行业从业或长期潜水经历，但具体职业、城市、年龄都没有公开可查的硬信息。",
    note: "更多来自行为侧写而非实据。",
    tag: "身份背景",
    size: "sm",
    tone: "secondary",
  },
  {
    id: "motive",
    index: "Q4",
    title: "动机：图名、图利，还是单纯图个热闹？",
    brief:
      "这是网友讨论最少却最影响可信度的一环——账号从未解释过自己为何持续爆料，匿名性本身让“为什么站出来”成为比“是谁”更难回答的问题。",
    note: "动机不明，影响账号可信度评估。",
    tag: "讨论焦点",
    size: "lg",
    tone: "secondary",
  },
];

export interface IndexItem {
  id: string;
  title: string;
  desc: string;
  source: string;
  status: "已回应" | "待求证" | "无实据" | "持续讨论";
}

export const indexItems: IndexItem[] = [
  {
    id: "i1",
    title: "某前从业者的“小号说”",
    desc: "认为四一爆料的选题偏好与某位前从业者过往作品高度重合，成为流传最广的一条对号入座说法。",
    source: "评论区 · 高赞整理",
    status: "待求证",
  },
  {
    id: "i2",
    title: "旧账号历史挖掘",
    desc: "有人翻出多个疑似其早年使用的账号，发文风格与现在并不完全一致，关联证据偏弱。",
    source: "网友整理帖",
    status: "无实据",
  },
  {
    id: "i3",
    title: "照片五官比对",
    desc: "一张据称是本人的工作照被多次引用，但拍摄者、场景、时间均无法考证。",
    source: "粉丝群转发",
    status: "待求证",
  },
  {
    id: "i4",
    title: "“圈内同行”侧面说法",
    desc: "声称与其有过私下沟通的匿名评论出现过不止一条，措辞相近但身份无法核验。",
    source: "讨论社区匿名发言",
    status: "持续讨论",
  },
  {
    id: "i5",
    title: "爆料地域与行业指向",
    desc: "根据多期内容推断其可能长期关注某一地区与细分行业，作为背景侧写参考。",
    source: "内容分析",
    status: "已回应",
  },
  {
    id: "i6",
    title: "主动回应与沉默记录",
    desc: "账号对被追问身份整体保持沉默，仅就内容准确性做过少量澄清，被视作“不认领”信号。",
    source: "账号历史动态",
    status: "已回应",
  },
];

export interface TimelineEvent {
  id: string;
  time: string;
  title: string;
  desc: string;
}

export const timelineEvents: TimelineEvent[] = [
  {
    id: "t1",
    time: "早期阶段",
    title: "开始发布爆料内容，风格圈定",
    desc: "账号以行业内部视角切入，逐步积累第一批关注，讨论热点集中在“内容够不够准”。",
  },
  {
    id: "t2",
    time: "关注攀升期",
    title: "阅读量上涨，“是谁”成为评论区高频词",
    desc: "随着内容被广泛转载，用户开始把注意力从内容本身转向账号背后的真实身份。",
  },
  {
    id: "t3",
    time: "猜测发酵期",
    title: "多版“对号入座”说法先后出现",
    desc: "围绕真名、照片与背景的多种说法在同一时段集中出现，真伪混杂，难以收敛。",
  },
  {
    id: "t4",
    time: "回应与沉默",
    title: "账号仅澄清内容，未正面回应身份",
    desc: "在多方追问下账号依旧保持匿名，身份疑云持续，讨论进入低烈度但持续的拉锯。",
  },
  {
    id: "t5",
    time: "当前阶段",
    title: "形成持续追踪的舆论样本",
    desc: "关于其可信度与来路的讨论沉淀为可索引的公开样本，供后来者对照与继续求证。",
  },
];

export interface CredibilityItem {
  id: string;
  axis: string;
  score: number;
  label: string;
  desc: string;
}

export const credibilityItems: CredibilityItem[] = [
  {
    id: "c1",
    axis: "内容准确度",
    score: 4,
    label: "偏高",
    desc: "已披露内容中获证实的部分占比较高，是其可信度的主要支撑。",
  },
  {
    id: "c2",
    axis: "身份透明",
    score: 1,
    label: "偏低",
    desc: "持续匿名，不披露背景与动机，构成评估里最大的减分项。",
  },
  {
    id: "c3",
    axis: "来源可溯",
    score: 2,
    label: "偏低",
    desc: "爆料缺少可核验的原始出处与证据链，转述占比高。",
  },
  {
    id: "c4",
    axis: "纠错意愿",
    score: 4,
    label: "偏高",
    desc: "面对内容层面的质疑有过澄清与修正，态度相对负责。",
  },
];

export const facts = [
  {
    id: "f1",
    value: "0",
    unit: "条",
    label: "被证实公开的真名线索",
    hint: "目前没有任何一条能落地",
  },
  {
    id: "f2",
    value: "3",
    unit: "组",
    label: "流传较广的照片说法",
    hint: "均缺少可信来源背书",
  },
  {
    id: "f3",
    value: "4",
    unit: "类",
    label: "身份背景的主流推测",
    hint: "由网友整理归类，非实据",
  },
  {
    id: "f4",
    value: "5",
    unit: "档",
    label: "已整理的说法线索",
    hint: "详见下方线索索引模块",
  },
];